import ApiService from '@/services/api.service';

const PostPaymentService = {
    getEraRemitList() {
        return ApiService.get(`PostPayment/eraRemitList`);
    },

    getPaymentFilteredList(parameter) {
        const params = {
            DateFrom: parameter.FromDate,
            DateTo: parameter.ToDate,
            Downloaded: parameter.Downloaded,
            Posted: parameter.Posted,
            InsuranceCodeList: parameter.InsuranceCodeList,
            SortIndex: parameter.SortIndex,
            hasErrors: parameter.hasErrors,
            SearchCriteria: parameter.SearchCriteria,
            PageSize: parameter.PageSize,
            PageNumber: parameter.PageNumber
        };
        return ApiService.getWithArray('/PostPayment/eraRemitFiltered/', params);
    },

    getInsurance() {
        return ApiService.get(`PostPayment/getInsuranceFilter`);
    },

    changeDownloadFlag(data) {
        return ApiService.put(`PostPayment/download`, data);
    },
    postPayment(data) {
        return ApiService.post(`PostPayment/postPayment`, data);
    },
    getTransNo(params) {
        return ApiService.get(`PostPayment/transNo/${params}`);
    },
    getPaymentDetails(params) {
        return ApiService.get(`PostPayment/details/${params}`);
    },

    /* getException(params){
        return ApiService.get(`PostPayment/exception?id=${params}`)
    },*/

    getException(parameter) {
        const params = {
            id: parameter.PaymentId
            //   PageSize: parameter.PageSize,
            //  PageNumber: parameter.PageNumber
        };
        return ApiService.getWithArray('PostPayment/exception', params);
    },

    getEraClaims(params) {
        return ApiService.get(
            `PostPayment/claimERA?PatientCode=${params.PatientCode}&DateFrom=${params.DateFrom}`
        );
    },
    validateIssLineNo(params) {
        return ApiService.get(
            `PostPayment/validateIss?IssLineNo=${params.IssLineNo}&PatientCode=${params.PatientCode}&Id=${params.Id}`
        );
    },
    getManualPayment(params) {
        return ApiService.getWithArray('PostPayment/manualPayment', params);
    },

    getPatientPayment(params) {
        return ApiService.getWithArray('PostPayment/patientPayment', params);
    },

    getPaymentPostingClaims(params) {
        return ApiService.getWithArray('PaymentPostingDraft/paymentClaims', params);
    },

    addPaymentPostingDraft(data) {
        return ApiService.post('PaymentPostingDraft', data);
    },

    updatePaymentPostingDraft(id, data) {
        return ApiService.put(`/PaymentPostingDraft/${id}`, data);
    },

    getPaymentPostingDraft(id) {
        return ApiService.get(`/PaymentPostingDraft/${id}`);
    },

    isDuplicatePay(data) {
        return ApiService.getWithArray('PaymentPostingDraft/isDuplicatePay', data);
    },

    processInsurancePay(data) {
        return ApiService.post('PaymentPostingDraft/processInsurancePay', data);
    },

    canProcessPayment(id) {
        return ApiService.get(`/PaymentPostingDraft/canProcessPay/${id}`);
    }
};

export default PostPaymentService;
